import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/employee/')({
  beforeLoad: () => {
    throw redirect({ to: '/employee/dashboard' });
  },
});